<template>
  <section>
    <b-modal :active="visible" has-modal-card :on-cancel="hideModal">
      <component :is="component" :title="modalTitle" :dataset="modalData" />
    </b-modal>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'AppModal',
  data() {
    return {
      component: null
    }
  },
  computed: {
    ...mapState('modal', {
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
      modalData: 'modalData',
      modalTitle: 'modalTitle'
    })
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  },
  watch: {
    modalComponent(componentName) {
      if (!componentName) return

      Vue.component(componentName, () => import(`./views/${componentName}`))
      this.component = componentName
    }
  }
}
</script>
